import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter[uie.source] = parameter;
  if (uie.source === 'ModuleId') {
    searchParameter['ModuleId'] = parameter;
  }
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let defaultFormData = { ...pageComponent.state.defaultFormData };
  defaultFormData[uie.source] = parameter;
  if (uie.source === 'ModuleId') {
    defaultFormData['moduleId'] = parameter;
  }
  pageComponent.setState({ defaultFormData });

  let filterLoaded = true;
  sectionComponent.state.section.componentList.filter(c => c.type === 'View')[0].topFilterList[0].uieList.map((uie, i) => {
    if (componentDefaultValue[uie.source] === undefined || componentDefaultValue[uie.source] === null) {
      filterLoaded = false;
    }
  })

  if (filterLoaded) {
    if (pageComponent.state.moduleId !== null) {
      defaultFormData['moduleId'] = parseInt(pageComponent.state.moduleId);
      searchParameter['ModuleId'] = parseInt(pageComponent.state.moduleId);
      componentDefaultValue['ModuleId'] = parseInt(pageComponent.state.moduleId);
      sectionComponent.setState({ searchParameter, componentDefaultValue });
      pageComponent.setState({ defaultFormData });
    }

    setTimeout(() => {
      sectionComponent.getSectionDataByDefault();
      pageComponent.setState({ moduleId: null });
    }, config.setTimeoutMilliSecond);
  }
}

export function addBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (!pageComponent.state.submitting) {
    pageComponent.setState({ submitting: true });
    let form = {};
    form.moduleId = pageComponent.state.defaultFormData.moduleId;
    httpClient
      .post('/Admin/JobDataTemplate', form)
      .then(({ data }) => {
        if (data.result) {
          pageComponent.setState({ submitting: false });
          pageComponent.props.history.push('/admin/job-data-template-detail/' + data.data.JobDataTemplateId);
        } else {
          pageComponent.setState({ submitting: false });
          globalFunction.handleResultError(data, pageComponent);
        }
      }).catch(function (error) {
        pageComponent.setState({ submitting: false });
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function showLabelDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageLabelShow: true });
  sectionComponent.child.current?.labelDiv.current?.getLabelList();
}
